export const summaryReport = {
  summaryReport: "Summary Report",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  username: "Username",
  cancel: "Cancel",
  filter: "Filter",
  exportReport: "Export Report",
  user: "USER",
  totalBetRounds: "TOTAL BET ROUNDS",
  betAmount: "BET AMOUNT",
  validBetAmount: "VALID BET AMOUNT",
  winloss: "WIN/LOSS",
  winlossPercent: "WIN/LOSS %",
};
